import { useMemo } from "react";
import { Picker } from "@design-system/Picker/Picker.lib";
import { GroupByOption, groupByTriggerLabel } from "./groupByTriggerLabel";

interface GroupBySelectProps<TKey extends string> {
    value: TKey;
    options: Array<GroupByOption<TKey>>;
    onValueChange: (value: TKey | null) => void;
}

export const GroupBySelect = <TKey extends string>({
    value,
    options,
    onValueChange,
}: GroupBySelectProps<TKey>) => {
    const triggerValue = groupByTriggerLabel({ value, options });
    const items = useMemo(
        () =>
            options.map((option) => ({
                value: option.key,
                label: option.label,
            })),
        [options],
    );

    return (
        <Picker.Select
            items={items}
            value={value}
            onValueChange={onValueChange}
            renderValue={() => triggerValue}
        />
    );
};
